import React, { useState, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import "../Auth/styles.css";

function PublicLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    let isAuth = JSON.parse(localStorage.getItem("access_token"));
    if (isAuth && isAuth !== null) {
      navigate("/clients");
    }
  }, [navigate]);

  return (
    <>
      <section>
        <div className="form-box">
          <Outlet />
        </div>
      </section>
    </>
  );
}

export default PublicLayout;
